export const copyText = {
  pcpTitle: 'Primary Care Provider (PCP)',
  callPcp: 'Call PCP',
  pcp: 'PCP',
  dentist: 'Dentist',
  noPcpSelected: 'No PCP has been selected.',
  addPcp: 'Add PCP',
  dentistTitle: 'Primary Care Dentist (PCD) ',
  noDentistSelected: 'No dentist has been selected.',
  addDentist: 'Add Dentist',
  cancel: 'Cancel',
  proceed: 'Proceed',
  modalDescription: 'text goes here',
  modalTitle: "You're leaving",
  iconSize: 'large',
  iconSet: 'product',
};
